import { factory } from "@mantine/core";
import { Children, Fragment, isValidElement } from "react";
import { IProps, AutoTableColumnFactory } from "./auto-table-column.types";
import { useAutoTableColumnContext } from "./auto-table-column-provider";
import { AutoTableColumnHeading } from "./auto-table-column-heading";
import { AutoTableColumnBody } from "./auto-table-column-body";
import { AutoTableColumnProvider } from "./auto-table-column-provider/auto-table-column-provider";

const AutoTableColumn = factory<AutoTableColumnFactory>(({ children }: IProps, ref) => {
    const { isBody } = useAutoTableColumnContext();
    return (
        <Fragment>
            {Children.toArray(children).filter(
                (child) =>
                    isValidElement(child) &&
                    ((!isBody && child.type === AutoTableColumnHeading) ||
                        (isBody && child.type !== AutoTableColumnHeading))
            )}
        </Fragment>
    );
});

AutoTableColumn.Header = AutoTableColumnHeading;
AutoTableColumn.Body = AutoTableColumnBody;
AutoTableColumn.Provider = AutoTableColumnProvider;

export { AutoTableColumn as TableColumn };
